'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _args = require('./args');

var _args2 = _interopRequireDefault(_args);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _args2.default; /**
                                   * Convert argument list to array (alias args)
                                   *
                                   * @module spread
                                   * @func
                                   * @since 1.17.0
                                   * @param {...*} args
                                   * @return {Array}
                                   * @example
                                   *
                                   *     spread(1, 2, 3); //=> [1, 2, 3]
                                   */